import styled, { css } from "styled-components";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { StyledTabLabelFieldProps } from "./types";

export const StyledTabLabelFieldErrorIcon = styled(ExclamationCircleOutlined)`
  margin-left: 0.5rem;
`;

export const StyledTabLabelField = styled.label<StyledTabLabelFieldProps>`
  cursor: pointer;

  ${({ hasError }) =>
    hasError &&
    css`
      color: #d4380d;
    `}
`;
